import addError from '../../../utils/error.jsx';

export function request(documentId, reportType) {
    return {
        type: 'REPORTS_EMAIL_REQUEST',
        documentId,
        reportType,
    };
}

export function error(documentId, errors) {
    addError(errors);

    return {
        type: 'REPORTS_EMAIL_ERROR',
        documentId,
        errors
    };
}

export function finish(documentId, data) {
    return {
        type: 'REPORTS_EMAIL_FINISH',
        documentId,
        data
    };
}

export function clear(documentId) {
    return {
        type: 'REPORTS_EMAIL_CLEAR',
        documentId
    };
}
